import type { MPLPreApprovalOffer } from 'commonTypes/api/scenarios/CreditSelectionScreenContent';

import { iso8601DurationToLoansTerm } from 'shared/lib';
import type { TLoansApplicationV2Data } from 'shared/types/TLoansService';

import type { TCreditFormCommonFields } from 'entities/creditForm';
import { CreditPurpose } from 'entities/creditForm/lib/formatters';
import { mapMplProductTypeToLeadGenProductType } from 'entities/scenario/lib';

import { mapMplSummariesToApplicationData } from './mapMplSummariesToApplicationData';

export type TAdditionalData = {
  affId?: string;
  [key: string]: string | boolean | number | undefined | null;
};

// eslint-disable-next-line complexity
export const mplOfferToPreApprovalDataAdapter = (
  offer: MPLPreApprovalOffer,
  formData: TCreditFormCommonFields,
  additionalData?: TAdditionalData,
): Pick<TLoansApplicationV2Data, 'customer' | 'other'> => {
  const termUnit = offer.productType === 'microcredit' ? 'day' : 'month';

  const { period: _, ...creditPurpose } = new CreditPurpose(formData).map();

  const customer: TLoansApplicationV2Data['customer'] = {
    ...mapMplSummariesToApplicationData(offer.summaries, offer.productType),
    productId: offer.productId,
    productName: offer.productName,
    productType: mapMplProductTypeToLeadGenProductType(offer.productType),
    organizationId: offer.organizationNewId,
    organizationName: offer.organizationName,
    ...creditPurpose,
    ...iso8601DurationToLoansTerm(formData.period?.value, termUnit),
  };

  return {
    customer,
    other: { ...(additionalData as TLoansApplicationV2Data['other']), groupName: 'Online' },
  };
};
